export const animeList = [
  {
    id: 1,
    slug: "cang-lan-jue",
    title: "苍兰诀",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20anime%20style%20illustration%2C%20beautiful%20female%20protagonist%20with%20long%20flowing%20hair%20in%20traditional%20fantasy%20costume%2C%20ethereal%20atmosphere%20with%20cherry%20blossoms%20and%20magical%20glowing%20elements%2C%20soft%20warm%20pink%20and%20golden%20tones%2C%20clean%20simple%20background%20with%20subtle%20gradient%2C%20anime%20key%20visual%20style%2C%20high%20quality%20illustration&width=600&height=840&seq=anime-cover-01&orientation=portrait",
    category: "奇幻",
    categorySlug: "fantasy",
    episodes: 36,
    status: "已完结",
    rating: 9.2,
    description: "在一个被仙魔之争笼罩的世界里，一位普通少女意外卷入了两界纷争。她将与冷酷的魔尊展开一段跨越生死的奇幻旅程，在爱与恨的边缘探寻真相。精致的画面与动人的配乐，打造出一部不可错过的国产动画佳作。",
    tags: ["奇幻", "恋爱", "古装", "国产"],
    year: 2023,
    region: "国产",
    director: "王裕仁",
    studio: "绘梦动画",
    voiceActors: ["杨凝", "刘明月", "赵爽"],
    views: 5800000,
  },
  {
    id: 2,
    slug: "gui-mie-zhi-ren",
    title: "鬼灭之刃",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20character%20illustration%2C%20young%20warrior%20with%20sword%20in%20dynamic%20action%20pose%2C%20water%20breathing%20effects%20with%20blue%20and%20green%20wave%20patterns%2C%20traditional%20Japanese%20setting%20with%20warm%20lighting%2C%20clean%20simple%20dark%20background%2C%20dramatic%20composition%2C%20high%20quality%20anime%20art&width=600&height=840&seq=anime-cover-02&orientation=portrait",
    category: "战斗",
    categorySlug: "action",
    episodes: 26,
    status: "已完结",
    rating: 9.5,
    description: "时值日本大正时期。卖炭少年炭治郎，在家人遭到鬼杀害后，为了寻找让变成鬼的妹妹祢豆子变回人类的方法，踏上了斩鬼之旅。少年与鬼的战斗，现在开始。",
    tags: ["战斗", "热血", "奇幻", "日本"],
    year: 2019,
    region: "日本",
    director: "外崎春雄",
    studio: "ufotable",
    voiceActors: ["花江夏树", "鬼头明里", "下野纮"],
    views: 12500000,
  },
  {
    id: 3,
    slug: "jian-lai",
    title: "剑来",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20anime%20cultivation%20style%20illustration%2C%20male%20swordsman%20with%20flowing%20robes%20holding%20ancient%20sword%2C%20mountainous%20landscape%20with%20mist%20and%20clouds%2C%20ink%20wash%20painting%20aesthetic%2C%20warm%20golden%20and%20red%20accents%2C%20clean%20simple%20background%20with%20soft%20gradient%2C%20epic%20fantasy%20mood&width=600&height=840&seq=anime-cover-03&orientation=portrait",
    category: "奇幻",
    categorySlug: "fantasy",
    episodes: 24,
    status: "连载中",
    rating: 9.0,
    description: "大千世界，无奇不有。少年陈平安，身怀绝世剑骨却命途多舛。在这个强者为尊的世界里，他凭借一把木剑，踏上了属于自己的剑道之路。命运的安排，让他在一次次生死历练中成长。",
    tags: ["奇幻", "武侠", "热血", "国产"],
    year: 2024,
    region: "国产",
    director: "沈乐平",
    studio: "玄机科技",
    voiceActors: ["赵路", "杨梦露", "沈达威"],
    views: 4200000,
  },
  {
    id: 4,
    slug: "zhou-shu-hui-zhan",
    title: "咒术回战",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20supernatural%20battle%20illustration%2C%20male%20protagonist%20with%20spiky%20hair%20in%20school%20uniform%20fighting%20pose%2C%20curse%20energy%20visual%20effects%20with%20dark%20purple%20and%20crimson%20auras%2C%20urban%20Tokyo%20night%20background%2C%20dynamic%20action%20composition%2C%20high%20quality%20anime%20art%20style&width=600&height=840&seq=anime-cover-04&orientation=portrait",
    category: "战斗",
    categorySlug: "action",
    episodes: 24,
    status: "连载中",
    rating: 9.4,
    description: "少年虎杖悠仁在吞下诅咒之王两面宿傩的手指后，踏入了诅咒与咒术的黑暗世界。为了收集散落各地的宿傩手指，他成为了东京都立咒术高专的学生，与同伴们一起对抗诅咒。",
    tags: ["战斗", "热血", "校园", "日本"],
    year: 2020,
    region: "日本",
    director: "朴性厚",
    studio: "MAPPA",
    voiceActors: ["榎木淳弥", "内田雄马", "濑户麻沙美"],
    views: 9800000,
  },
  {
    id: 5,
    slug: "dou-luo-da-lu",
    title: "斗罗大陆",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20anime%20fantasy%20illustration%2C%20young%20male%20hero%20with%20blue%20hair%20and%20determined%20expression%2C%20martial%20arts%20cultivation%20theme%2C%20magical%20spirit%20rings%20glowing%20around%20character%2C%20epic%20fantasy%20world%20background%20with%20castles%20and%20mountains%2C%20golden%20and%20azure%20color%20scheme%2C%20clean%20simple%20composition&width=600&height=840&seq=anime-cover-05&orientation=portrait",
    category: "奇幻",
    categorySlug: "fantasy",
    episodes: 263,
    status: "已完结",
    rating: 9.3,
    description: "唐门外门弟子唐三，因偷学内门绝学为唐门所不容，跳崖明志时却来到了另一个世界——斗罗大陆。在这里，没有魔法，没有斗气，没有武术，却有神奇的武魂。唐三能否在这片武魂的世界再铸唐门的辉煌？",
    tags: ["奇幻", "热血", "冒险", "国产"],
    year: 2018,
    region: "国产",
    director: "沈乐平",
    studio: "玄机科技",
    voiceActors: ["赵乾景", "谢莹", "刘垚"],
    views: 35000000,
  },
  {
    id: 6,
    slug: "jian-shi",
    title: "间谍过家家",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20family%20comedy%20illustration%2C%20elegant%20female%20assassin%20with%20rose%20gold%20hair%20in%20stylish%20outfit%2C%20spy%20themed%20composition%20with%20playful%20mood%2C%20warm%20pastel%20color%20palette%20with%20soft%20pink%20and%20cream%20tones%2C%20clean%20simple%20background%2C%20heartwarming%20atmosphere%2C%20high%20quality%20anime%20art&width=600&height=840&seq=anime-cover-06&orientation=portrait",
    category: "搞笑",
    categorySlug: "comedy",
    episodes: 25,
    status: "连载中",
    rating: 9.3,
    description: "为了执行任务，顶尖间谍「黄昏」组建了一个临时家庭。但他万万没想到，妻子是职业杀手，女儿是超能力者。这个各怀秘密的家庭，却在日常生活中产生了真正的羁绊。",
    tags: ["搞笑", "日常", "家庭", "日本"],
    year: 2022,
    region: "日本",
    director: "古桥一浩",
    studio: "WIT STUDIO x CloverWorks",
    voiceActors: ["江口拓也", "种崎敦美", "早见沙织"],
    views: 11200000,
  },
  {
    id: 7,
    slug: "fan-ren-xiu-xian-zhuan",
    title: "凡人修仙传",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20anime%20cultivation%20fantasy%20illustration%2C%20determined%20male%20cultivator%20in%20simple%20gray%20robes%2C%20standing%20on%20misty%20mountain%20peak%2C%20ancient%20Chinese%20landscape%20with%20pine%20trees%20and%20waterfalls%2C%20realistic%203D%20rendering%20style%2C%20atmospheric%20lighting%20with%20sunrise%20warmth%2C%20clean%20composition&width=600&height=840&seq=anime-cover-07&orientation=portrait",
    category: "奇幻",
    categorySlug: "fantasy",
    episodes: 72,
    status: "连载中",
    rating: 9.1,
    description: "一个普通的山村穷小子，偶然之下进入了一个江湖小门派。虽然资质平庸，但依靠自身努力和合理算计，一步步踏上修仙之路。凡人修仙，逆天改命。",
    tags: ["奇幻", "修仙", "冒险", "国产"],
    year: 2020,
    region: "国产",
    director: "王昕",
    studio: "原力动画",
    voiceActors: ["赵路", "王梓", "夏磊"],
    views: 7800000,
  },
  {
    id: 8,
    slug: "yao-shen-ji",
    title: "妖神记",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20anime%20reincarnation%20fantasy%20illustration%2C%20young%20boy%20with%20magical%20spirit%20companion%20in%20ancient%20setting%2C%20fantasy%20creatures%20and%20spirit%20beasts%2C%20vibrant%20warm%20orange%20and%20golden%20color%20scheme%2C%20adventure%20mood%2C%20clean%20simple%20background%2C%20anime%20style%20illustration&width=600&height=840&seq=anime-cover-08&orientation=portrait",
    category: "冒险",
    categorySlug: "adventure",
    episodes: 156,
    status: "连载中",
    rating: 8.8,
    description: "妖灵师聂离，重生回到少年时代。这一世，他要弥补所有遗憾，守护想要守护的人，踏上妖灵之王的巅峰之路。带着前世的记忆，他将改变所有人的命运。",
    tags: ["冒险", "奇幻", "重生", "国产"],
    year: 2019,
    region: "国产",
    director: "杨磊",
    studio: "若鸿文化",
    voiceActors: ["赵路", "刘北辰", "杨鸥"],
    views: 6500000,
  },
  {
    id: 9,
    slug: "tian-guan-ci-fu",
    title: "天官赐福",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20anime%20romance%20fantasy%20illustration%2C%20elegant%20male%20figure%20in%20white%20flowing%20traditional%20robes%20with%20red%20accents%2C%20heavenly%20palace%20background%20with%20golden%20clouds%2C%20cherry%20blossom%20petals%20scattered%2C%20romantic%20and%20ethereal%20atmosphere%2C%20soft%20lighting%2C%20clean%20simple%20composition&width=600&height=840&seq=anime-cover-09&orientation=portrait",
    category: "恋爱",
    categorySlug: "romance",
    episodes: 12,
    status: "已完结",
    rating: 9.4,
    description: "八百年前，谢怜是金枝玉叶的太子殿下。八百年后，他却成了破烂仙人。在凡间捡破烂的某一天，他带回了一个神秘的红衣少年。身份谜团、天庭阴谋、前世今生的羁绊，都在两人的相遇中逐渐揭开。",
    tags: ["恋爱", "奇幻", "古装", "国产"],
    year: 2020,
    region: "国产",
    director: "李豪凌",
    studio: "绘梦动画",
    voiceActors: ["姜广涛", "马正阳", "赵毅"],
    views: 8900000,
  },
  {
    id: 10,
    slug: "yi-ren-zhi-xia",
    title: "一人之下",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20modern%20supernatural%20anime%20illustration%2C%20young%20male%20protagonist%20with%20casual%20modern%20clothing%2C%20martial%20arts%20stance%20with%20energy%20effects%2C%20urban%20Chinese%20city%20background%2C%20mix%20of%20traditional%20and%20modern%20elements%2C%20dynamic%20composition%2C%20warm%20earthy%20tones%2C%20clean%20simple%20background&width=600&height=840&seq=anime-cover-10&orientation=portrait",
    category: "战斗",
    categorySlug: "action",
    episodes: 60,
    status: "连载中",
    rating: 9.2,
    description: "平凡大学生张楚岚，因为爷爷的离世，平静的生活被打破。一个神秘少女的出现，将他卷入了异人的世界。在这个隐藏在现代社会背后的异能者江湖中，他发现了关于自己的惊天秘密。",
    tags: ["战斗", "热血", "现代", "国产"],
    year: 2016,
    region: "国产",
    director: "王昕",
    studio: "绘梦动画",
    voiceActors: ["宝木中阳", "山新", "夏磊"],
    views: 7200000,
  },
  {
    id: 11,
    slug: "jin-ji-de-ju-ren",
    title: "进击的巨人",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20dark%20fantasy%20anime%20illustration%2C%20soldiers%20in%20military%20uniform%20with%20omni-directional%20mobility%20gear%2C%20dramatic%20action%20scene%20with%20steam%20effects%2C%20giant%20wall%20and%20medieval%20architecture%20in%20background%2C%20dark%20moody%20atmosphere%20with%20warm%20golden%20highlights%2C%20epic%20scale&width=600&height=840&seq=anime-cover-11&orientation=portrait",
    category: "战斗",
    categorySlug: "action",
    episodes: 87,
    status: "已完结",
    rating: 9.7,
    description: "在巨人的威胁下，人类被迫居住在高墙之内。少年艾伦·耶格尔目睹母亲被巨人吞噬后，立誓要将所有巨人驱逐出去。然而随着真相逐渐揭开，他发现自己面对的远不止巨人那么简单。",
    tags: ["战斗", "热血", "悬疑", "日本"],
    year: 2013,
    region: "日本",
    director: "荒木哲郎",
    studio: "WIT STUDIO / MAPPA",
    voiceActors: ["梶裕贵", "石川由依", "井上麻里奈"],
    views: 28000000,
  },
  {
    id: 12,
    slug: "xia-ri-zhong-xian",
    title: "夏日重现",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20mystery%20summer%20island%20illustration%2C%20young%20couple%20on%20beach%20at%20sunset%2C%20tropical%20island%20setting%20with%20palm%20trees%2C%20mysterious%20and%20suspenseful%20atmosphere%2C%20warm%20orange%20and%20crimson%20sunset%20colors%2C%20clean%20simple%20composition%2C%20high%20quality%20anime%20art&width=600&height=840&seq=anime-cover-12&orientation=portrait",
    category: "悬疑",
    categorySlug: "mystery",
    episodes: 25,
    status: "已完结",
    rating: 9.1,
    description: "为了参加青梅竹马潮的葬礼，网代慎平回到了阔别已久的故乡日都岛。然而，岛上似乎发生了某种异变，慎平发现自己陷入了时间的循环之中。为了拯救岛上的人们，他必须找出真相。",
    tags: ["悬疑", "推理", "恋爱", "日本"],
    year: 2022,
    region: "日本",
    director: "渡边步",
    studio: "OLM",
    voiceActors: ["花江夏树", "永濑安奈", "白砂沙帆"],
    views: 3500000,
  },
];

export const featuredAnime = [
  {
    id: 2,
    slug: "gui-mie-zhi-ren",
    title: "鬼灭之刃",
    description: "斩鬼少年的热血冒险，现象级动画巨作",
    cover: "https://readdy.ai/api/search-image?query=Epic%20Japanese%20anime%20key%20visual%2C%20demon%20slayer%20warrior%20with%20nichirin%20sword%20surrounded%20by%20flame%20and%20water%20effects%2C%20dramatic%20lighting%20with%20warm%20orange%20and%20cool%20blue%20contrast%2C%20cinematic%20composition%2C%20traditional%20Japanese%20aesthetic%2C%20high%20quality%20anime%20illustration&width=900&height=1200&seq=featured-01&orientation=portrait",
  },
  {
    id: 11,
    slug: "jin-ji-de-ju-ren",
    title: "进击的巨人",
    description: "自由之翼的史诗终章，不容错过",
    cover: "https://readdy.ai/api/search-image?query=Epic%20dark%20fantasy%20anime%20visual%2C%20colossal%20giant%20looming%20over%20medieval%20city%20walls%2C%20dramatic%20apocalyptic%20atmosphere%2C%20golden%20sunset%20lighting%20breaking%20through%20dark%20clouds%2C%20cinematic%20scale%20and%20composition%2C%20high%20quality%20illustration&width=900&height=1200&seq=featured-02&orientation=portrait",
  },
  {
    id: 5,
    slug: "dou-luo-da-lu",
    title: "斗罗大陆",
    description: "国产动画里程碑，263集完整史诗",
    cover: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20anime%20visual%2C%20team%20of%20young%20heroes%20with%20glowing%20spirit%20rings%2C%20ancient%20Chinese%20architecture%20and%20magical%20landscapes%2C%20golden%20and%20azure%20divine%20lighting%2C%20heroic%20composition%2C%20high%20quality%20illustration&width=900&height=1200&seq=featured-03&orientation=portrait",
  },
];

export const categories = [
  { slug: "action", name: "热血战斗", description: "激情澎湃的战斗番剧", count: 128, icon: "ri-sword-line" },
  { slug: "fantasy", name: "奇幻冒险", description: "异世界与魔法之旅", count: 96, icon: "ri-magic-line" },
  { slug: "romance", name: "恋爱日常", description: "甜蜜温暖的恋爱故事", count: 74, icon: "ri-heart-line" },
  { slug: "comedy", name: "搞笑喜剧", description: "欢乐轻松的搞笑番剧", count: 63, icon: "ri-emotion-laugh-line" },
  { slug: "adventure", name: "冒险成长", description: "热血旅途与成长故事", count: 58, icon: "ri-compass-3-line" },
  { slug: "mystery", name: "悬疑推理", description: "烧脑刺激的推理之旅", count: 42, icon: "ri-search-eye-line" },
  { slug: "scifi", name: "科幻未来", description: "未来世界的科幻畅想", count: 38, icon: "ri-rocket-line" },
];

export const articles = animeList;

export interface Anime {
  id: number;
  slug: string;
  title: string;
  cover: string;
  category: string;
  categorySlug: string;
  episodes: number;
  status: string;
  rating: number;
  description: string;
  tags: string[];
  year: number;
  region: string;
  director: string;
  studio: string;
  voiceActors: string[];
  views: number;
}

export interface FeaturedAnime {
  id: number;
  slug: string;
  title: string;
  description: string;
  cover: string;
}

export interface Category {
  slug: string;
  name: string;
  description: string;
  count: number;
  icon: string;
}
